// Posts straight to Klaviyo's client API so signup works without Klaviyo's script.
// Guard: two newsletter sections on one page would load this asset twice.
if (!customElements.get('klaviyo-newsletter-form')) {
  customElements.define(
    'klaviyo-newsletter-form',
    class KlaviyoNewsletterForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.message = this.querySelector('[data-message]');
        this.button = this.querySelector('button[type="submit"]');
        this.form.addEventListener('submit', this.onSubmit.bind(this));
      }

      async onSubmit(event) {
        event.preventDefault();

        // Required fields are enforced by the browser before submit fires.
        const data = new FormData(this.form);
        const attributes = {
          email: data.get('email').trim(),
          first_name: data.get('first_name').trim(),
          subscriptions: {email: {marketing: {consent: 'SUBSCRIBED'}}},
        };
        const lastName = data.get('last_name').trim();
        if (lastName) attributes.last_name = lastName;

        this.setState('pending');

        try {
          const response = await fetch(
            `https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(
              this.dataset.companyId
            )}`,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/vnd.api+json',
                revision: this.dataset.revision,
              },
              body: JSON.stringify({
                data: {
                  type: 'subscription',
                  attributes: {
                    profile: {
                      data: {type: 'profile', attributes},
                    },
                  },
                  relationships: {list: {data: {type: 'list', id: this.dataset.listId}}},
                },
              }),
            }
          );

          if (response.status === 202) {
            this.form.reset();
            this.setState('success');
          } else {
            this.setState('error');
          }
        } catch (error) {
          this.setState('error');
        }
      }

      setState(state) {
        this.button.disabled = state === 'pending';
        this.message.textContent = this.dataset[`${state}Text`] || '';
      }
    }
  );
}
